import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  InputAdornment,
  IconButton,
  useTheme,
  useMediaQuery,
  Avatar,
  Stack,
  Divider,
} from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Visibility, VisibilityOff, Email, Lock, AdminPanelSettings, Login as LoginIcon } from '@mui/icons-material';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // بيانات الدخول الصحيحة
  const validCredentials = {
    email: 'RuknAlmrooj@gmail.com',
    password: '123456789'
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    setTimeout(() => {
      if (formData.email === validCredentials.email && 
          formData.password === validCredentials.password) {
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('userEmail', formData.email);
        navigate('/admin/dashboard');
      } else {
        setError('❌ البريد الإلكتروني أو كلمة المرور غير صحيحة');
      }
      setLoading(false);
    }, 1000);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #0a0a2a 0%, #1a1a3a 50%, #0a0a2a 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Animated Background Elements */}
      <motion.div
        animate={{
          scale: [1, 1.3, 1],
          rotate: [0, 45, 0],
          opacity: [0.05, 0.1, 0.05],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          position: 'absolute',
          top: '10%',
          right: '5%',
          width: '400px',
          height: '400px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(212,175,55,0.15) 0%, rgba(212,175,55,0) 70%)',
          zIndex: 0,
        }}
      />

      <motion.div
        animate={{
          scale: [1, 1.2, 1],
          rotate: [0, -45, 0],
          opacity: [0.05, 0.08, 0.05],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: "linear",
          delay: 1,
        }}
        style={{
          position: 'absolute',
          bottom: '10%',
          left: '5%',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(212,175,55,0.1) 0%, rgba(212,175,55,0) 70%)',
          zIndex: 0,
        }}
      />

      {/* Floating particles */}
      {[...Array(8)].map((_, i) => (
        <motion.div
          key={i}
          animate={{
            y: [0, -100, 0],
            x: [0, (i % 2 === 0 ? 50 : -50), 0],
            opacity: [0, 0.3, 0],
          }}
          transition={{
            duration: 5 + i,
            repeat: Infinity,
            ease: "easeInOut",
            delay: i * 0.5,
          }}
          style={{
            position: 'absolute',
            width: 4,
            height: 4,
            borderRadius: '50%',
            background: '#c9a03d',
            left: `${10 + i * 10}%`,
            top: '50%',
            zIndex: 0,
          }}
        />
      ))}

      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, type: "spring", stiffness: 100 }}
        >
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, sm: 5 },
              borderRadius: '28px',
              background: 'rgba(255, 255, 255, 0.98)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(212,175,55,0.2)',
              boxShadow: '0 25px 50px rgba(0,0,0,0.15)',
            }}
          >
            {/* Logo / Icon */}
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <motion.div
                animate={{ 
                  rotate: [0, 10, -10, 0],
                  scale: [1, 1.05, 1]
                }}
                transition={{ 
                  duration: 3, 
                  repeat: Infinity,
                  repeatDelay: 2,
                  ease: "easeInOut" 
                }}
              >
                <Avatar
                  sx={{
                    width: { xs: 70, sm: 90 },
                    height: { xs: 70, sm: 90 },
                    mx: 'auto',
                    mb: 2,
                    background: 'linear-gradient(135deg, #c9a03d 0%, #a07d2e 100%)',
                    boxShadow: '0 10px 25px rgba(201,160,61,0.3)',
                  }}
                >
                  <AdminPanelSettings sx={{ fontSize: { xs: 40, sm: 50 }, color: '#fff' }} />
                </Avatar>
              </motion.div>

              <Typography
                variant="h4"
                sx={{
                  fontWeight: 'bold',
                  background: 'linear-gradient(135deg, #c9a03d 0%, #a07d2e 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  mb: 1,
                  fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem' },
                }}
              >
                مرحباً بعودتك
              </Typography>
              <Typography variant="body2" sx={{ color: '#666' }}>
                يرجى تسجيل الدخول للوصول إلى لوحة التحكم
              </Typography>
            </Box>

            {/* Decorative Line */}
            <Divider sx={{ my: 3, '&::before, &::after': { borderColor: 'rgba(212,175,55,0.3)' } }}>
              <Typography variant="caption" sx={{ color: '#c9a03d', fontWeight: 500 }}>
                تسجيل الدخول
              </Typography>
            </Divider>

            {/* Error Message */}
            {error && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
              >
                <Alert 
                  severity="error" 
                  sx={{ 
                    mb: 3, 
                    borderRadius: '14px',
                    backgroundColor: '#fff3e0',
                    color: '#c9a03d',
                    '& .MuiAlert-icon': { color: '#c9a03d' }
                  }}
                >
                  {error}
                </Alert>
              </motion.div>
            )}

            {/* Login Form */}
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                name="email"
                label="البريد الإلكتروني"
                value={formData.email}
                onChange={handleChange}
                margin="normal"
                required
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email sx={{ color: '#c9a03d' }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '14px',
                    backgroundColor: '#f8f9fa',
                    '&:hover fieldset': {
                      borderColor: '#c9a03d',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#c9a03d',
                    },
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: '#c9a03d',
                  },
                }}
              />

              <TextField
                fullWidth
                name="password"
                label="كلمة المرور"
                type={showPassword ? 'text' : 'password'}
                value={formData.password}
                onChange={handleChange}
                margin="normal"
                required
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock sx={{ color: '#c9a03d' }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{ color: '#c9a03d' }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '14px',
                    backgroundColor: '#f8f9fa',
                    '&:hover fieldset': {
                      borderColor: '#c9a03d',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#c9a03d',
                    },
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: '#c9a03d',
                  },
                }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                disabled={loading}
                endIcon={!loading && <LoginIcon />}
                sx={{
                  mt: 4,
                  py: 1.5,
                  background: 'linear-gradient(135deg, #c9a03d 0%, #a07d2e 100%)',
                  borderRadius: '40px',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  textTransform: 'none',
                  boxShadow: '0 8px 20px rgba(201,160,61,0.3)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #a07d2e 0%, #c9a03d 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 25px rgba(201,160,61,0.4)',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                {loading ? (
                  <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                  >
                    ⏳
                  </motion.div>
                ) : (
                  'تسجيل الدخول'
                )}
              </Button>
            </form>

            {/* Demo Credentials */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              <Box sx={{ mt: 4, textAlign: 'center' }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    background: 'rgba(212,175,55,0.08)',
                    borderRadius: '14px',
                    border: '1px solid rgba(212,175,55,0.2)',
                  }}
                >
                  <Typography variant="caption" sx={{ color: '#666', display: 'block', mb: 1 }}>
                    🔐 بيانات الدخول التجريبية:
                  </Typography>
                  <Stack direction="row" spacing={2} justifyContent="center" sx={{ flexWrap: 'wrap', gap: 1 }}>
                    <Typography variant="caption" sx={{ color: '#c9a03d', fontWeight: 500 }}>
                      📧 RuknAlmrooj@gmail.com
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#c9a03d', fontWeight: 500 }}>
                      🔑 123456789
                    </Typography>
                  </Stack>
                </Paper>
              </Box>
            </motion.div>

            {/* Back to Home Link */}
            <Box sx={{ mt: 3, textAlign: 'center' }}>
              <Button
                onClick={() => navigate('/')}
                sx={{
                  color: '#666',
                  textTransform: 'none',
                  fontSize: '0.8rem',
                  '&:hover': { color: '#c9a03d' },
                }}
              >
                ← العودة إلى الصفحة الرئيسية
              </Button>
            </Box>
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Login;